import { Button } from '../../../atoms/Button';
import { Icon } from '../../../atoms/Icon';
import { ListIcon } from 'morpheus-ui';
import { Typography } from '../../Typography';
import { useExamNavigationHook } from '../../../../hooks/examNavigation';
import { ReactNode } from 'react';

interface ExamNavigationProps {
  exercisesDone: number;
  totalExercises: number;
  timeLeft?: number;
  isLoading?: boolean;
  isPractice?: boolean;
  onFinish: (isTimeExpired?: boolean) => void;
  onPrint: () => void;
  onAnswerCardClick?: () => void;
  /**
   * Relogio proprio no lugar da contagem regressiva de `timeLeft` (ex.: o
   * cronometro progressivo da Area ENEM). Ausente, nada muda.
   */
  timer?: ReactNode;
}

export default function ExamNavigation({
  exercisesDone,
  totalExercises,
  timeLeft,
  isPractice = false,
  isLoading = false,
  onFinish,
  onPrint,
  onAnswerCardClick,
  timer,
}: ExamNavigationProps) {
  const { formattedTime, innerWidth } = useExamNavigationHook(
    timeLeft || 0,
    onFinish,
    isPractice
  );

  if (innerWidth < 740) {
    return (
      <footer className='font-noto fixed bottom-0 left-0 flex h-20 w-full justify-between flex-row items-center gap-xl border-t-hairline border-t-mono-color-lightest bg-color-lightest px-4 py-5 shadow-level-2'>
        <div className='bg-mono-200 flex items-center gap-md rounded-pill'>
          <Button
            allowReadOnly
            LeftIcon={ListIcon}
            iconType='svg'
            iconSize='small'
            variant='text'
            size='small'
            onClick={onAnswerCardClick}
          >
            {exercisesDone}/{totalExercises}
          </Button>
        </div>
        {timer && (
          <div className='flex flex-1 items-center justify-center text-center'>
            {timer}
          </div>
        )}
        {!timer && timeLeft && (
          <div className='flex flex-1 items-center justify-center gap-xs text-center'>
            <Icon
              Icon='schedule'
              type='material'
              className='text-mono-color-dark'
            />
            <Typography>{formattedTime}</Typography>
          </div>
        )}
        <Button
          LeftIcon='task_alt'
          onClick={() => onFinish()}
          disabled={isLoading}
        >
          Finalizar
        </Button>
      </footer>
    );
  }

  return (
    <footer
      className='
        font-noto fixed bottom-0 left-0
        flex h-20 w-full flex-row items-center
        justify-between gap-xl border-t-hairline border-t-mono-color-lightest bg-color-lightest
        px-8 py-5 shadow-level-2 z-10 md:mb-[70px] lg:mb-0
      '
    >
      <Button allowReadOnly LeftIcon='print' variant='outlined' onClick={onPrint}>
        Imprimir<span className='hidden lg:block'> simulado</span>
      </Button>
      <div className='flex gap-xxl'>
        {timer && (
          <div className='flex items-center justify-center text-center'>
            {timer}
          </div>
        )}
        {!timer && timeLeft && (
          <div className='flex items-center justify-center gap-xs text-center'>
            <Icon
              Icon='schedule'
              type='material'
              className='text-mono-color-dark'
            />
            <Typography>{formattedTime}</Typography>
          </div>
        )}
        <div className='flex w-[289px] items-center gap-md rounded-pill bg-color-lighter px-4 py-2 md:w-[274px] lg:w-[388px]'>
          <div className='h-2 w-full rounded-pill bg-mono-color-white'>
            <div
              style={{ width: `${(exercisesDone / totalExercises) * 100}%` }}
              className='h-2 rounded-pill bg-brand-color-primary-light'
            ></div>
          </div>
          <Button
            allowReadOnly
            LeftIcon={ListIcon}
            iconType='svg'
            iconSize='small'
            variant='text'
            size='small'
            classNameIcon='fill-button-color-tertiary-default'
            onClick={onAnswerCardClick}
          >
            {exercisesDone}/{totalExercises}
          </Button>
        </div>
      </div>
      <Button
        LeftIcon='task_alt'
        onClick={() => onFinish()}
        disabled={isLoading}
      >
        Finalizar<span className='hidden lg:block'> simulado</span>
      </Button>
    </footer>
  );
}
